import { render, staticRenderFns } from "./VentaDistintaButaca.vue?vue&type=template&id=e87b715c"
import script from "./VentaDistintaButaca.vue?vue&type=script&lang=js"
export * from "./VentaDistintaButaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports